import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserPermissionsDirective } from './user-permissions.directive';
import { AdminProfileCheck } from './user-profile.directive';
import { AccountBreakpointVersion } from './check-account-access.directive';
import { AccountBreakpointVersionMaterialComponent } from './check--access-mat-component.directive';
import { StylePaginatorDirective } from './style-paginator.directive';
import { UppercaseInputDirective } from './uppercase-input.directive';



@NgModule({
  declarations: [
    UserPermissionsDirective, 
    AdminProfileCheck,
    AccountBreakpointVersion,
    AccountBreakpointVersionMaterialComponent,
    StylePaginatorDirective,
    UppercaseInputDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    UserPermissionsDirective,
    AdminProfileCheck,
    AccountBreakpointVersion,
    AccountBreakpointVersionMaterialComponent,
    StylePaginatorDirective,
    UppercaseInputDirective
  ],
})
export class DirectivesModule { }
